import { changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { TOASTER_STATE } from '../../../Model/Enums';
import { currentCompanySelector, setCurrentCompany } from '../../../Store/paramsBagSlice';
import { SubmitHandler, UseFormRegister } from 'react-hook-form';
import { Accountant } from '../../../Model/Accountant';
import { Company } from "../../../Model/Company";
import { useGenerateMailMutation } from '../../../Store/company';

export const useCourierEmailGenerateForm = (
  register: UseFormRegister<Partial<Company>>,
  reset: () => void
) => {
  const dispatch = useAppDispatch();
  const currentCompany = useAppSelector(currentCompanySelector);
  const [generateMail, {isLoading: inProgress}] = useGenerateMailMutation();

  const onSubmit: SubmitHandler<Partial<Accountant>> = async () => {
    try {
      dispatch(setCurrentCompany(
        await generateMail(currentCompany).unwrap()
      ));
      dispatch(changeToasterState(TOASTER_STATE.COURIER_EMAIL_GENERATE_SUCCESS));
      reset();
    } catch (e) {
      dispatch(changeToasterState(TOASTER_STATE.COURIER_EMAIL_GENERATE_FAILED));
    }
  };

  const copyToClipboard = async (data) => {
    navigator.clipboard.writeText(data);
  };

  const onClose = () => {
    dispatch(toggleModal());
  };

  return { onSubmit, inProgress, copyToClipboard, currentCompany, onClose };
};
